import { type SelectOption } from '../../../../../components';

export enum PRIORITIZE_EDIT_MODE {
  DRAG_MODE = 'DRAG_MODE',
  INPUT_MODE = 'INPUT_MODE',
}

export const prioritizeModeOptions: SelectOption[] = [
  { value: PRIORITIZE_EDIT_MODE.INPUT_MODE, label: 'Input Mode' },
  { value: PRIORITIZE_EDIT_MODE.DRAG_MODE, label: 'Drag Mode' },
];
